export const LOADER = "UPDATE_LOADER";
export const SEARCHPARAMS = "UPDATE_SEARCH_PARAMS";
export const SEARCHRESULT = "UPDATE_SEARCH_RESULT";
export const MODIFYSEARCHRESULT = "MODIFY_SEARCH_RESULT";
export const SELBUS = "UPDATE_SEL_BUS";
export const ROUTEINFO = "UPDATE_ROUTE_INFO";
export const ROUTEINFOBYID = "UPDATE_ROUTE_INFO_BYID"
export const CHARTDATA = "UPDATE_CHART_DATA";
export const ORDERDATA = "UPDATE_ORDER_DATA";
export const COUPONLIST = "UPDATE_COUPON_LIST";
export const ALERT = "UPDATE_ALERT";
export const GENERATEOTP = "GENERATE_OTP";
export const VALIDATEOTP = "VALIDATE_OTP";
export const SAVEPROFILE = "SAVE_PROFILE";
export const WAITLISTMSG = "WAIT_LIST_MSG";
export const UPDATEBUSSORT = "UPDATE_BUS_SORT";
export const UPDATESELPICKDTLS = "UPDATE_SEL_PICK_DTLS";
export const UPDATESELDROPDTLS = "UPDATE_SEL_DROP_DTLS";
export const UPDATESELBUSPICKINFO = "UPDATE_SEL_BUS_PICK_INFO";
export const UPDATESERVICEROUTEINFO = "UPDATE_SERVICE_ROUTE_INFO";
export const TRIPINFOBYID = "TRIPINFOBYID";
export const UPDATESEATCHARTERROR = "UPDATE_SEATCHART_ERROR";
export const UPDATESERVICETYPES = "UPDATE_SERVICE_TYPES";
export const UPDATE_ROUTES_PKPDRP = "UPDATE_ROUTES_PKPDRP";
export const UPDATE_FARE_RANGE = "UPDATE_FARE_RANGE";
export const UPDATE_CONCESSION_LEVY_LIST = "UPDATE_CONCESSION_LEVY_LIST";
export const UPDATE_CONCESSION_LEVY_FOR_ROUTEID = "UPDATE_CONCESSION_LEVY_FOR_ROUTEID";
export const UPDATE_CAPTCHA_TOKEN = "UPDATE_CAPTCHA_TOKEN";
export const FLEXIDATA            = "FLEXIDATA";



export const SEARCHPACKAGEPARAMS = "UPDATE_SEARCH_PACKAGE_PARAMS";
export const UPDATE_SEARCH_TOUR_PACKAGE_RES = "UPDATE_SEARCH_TOUR_PACKAGE_RES";
export const UPDATE_PICKUP_POINTS = "UPDATE_PICKUP_POINTS";
export const SELPACKAGE = "UPDATE_SEL_PACKAGE";
export const UPDATE_PKG_SEL_PICK_DTLS = "UPDATE_PKG_SEL_PICK_DTLS";
export const UPDATE_ACCO_TYPE_DATA = "UPDATE_ACCO_TYPE_DATA";


export const UPDATE_PKG_SEL_ACCO_DTLS = "UPDATE_PKG_SEL_ACCO_DTLS";
export const UPDATE_PKG_NO_OF_PAX = "UPDATE_PKG_NO_OF_PAX";
export const UPDATE_PKG_CHART_DATA = "UPDATE_PKG_CHART_DATA";
export const UPDATE_PKG_SEAT_CHART_ERROR = "UPDATE_PKG_SEAT_CHART_ERROR";

export const UPDATE_SEAT_WISE_FARE = "UPDATE_SEAT_WISE_FARE";
export const UPDATE_SEAT_WISE_SR_FARE = "UPDATE_SEAT_WISE_SR_FARE";

export const UPDATE_PKG_ORDER_DATA = "UPDATE_PKG_ORDER_DATA";